import { useState, useEffect } from 'react';

interface UseValidationProps {
  maxLength?: number;
  value?: string;
  validateOnStart?: boolean;
  validateForm?: number;
  setFieldError: ({ name, value }: { name: string; value: boolean }) => void;
  setFieldValue: ({ name, value }: { name: string; value: string }) => void;
  name: string;
  isRequired?: boolean;
}

export const useValidation = ({
  maxLength = 30,
  value,
  validateOnStart = false,
  validateForm = 0,
  setFieldError,
  setFieldValue,
  name,
  isRequired
}: UseValidationProps) => {
  const [errorText, setErrorText] = useState('');

  const validate = (inputValue: string) => {
    if (inputValue.length > maxLength) {
      setErrorText('Excediste el número de caracteres');
      return true;
    }
    setErrorText('');
    return false;
  };

  const setValue = (newValue: string) => {
    setFieldError({ name, value: validate(newValue) });
    setFieldValue({ name, value: newValue });
  };

  useEffect(() => {
    if (validateForm === 0) return;
    if (
      ((validateOnStart || validateForm > 0) && !value) ||
      (isRequired && !value) ||
      (isRequired && value === ' ')
    ) {
      setErrorText('Dato pendiente');
    }
  }, [validateOnStart, validateForm, value]);

  return { errorText, setValue };
};
